<template>
  <component :is="tag" :class="classes"><slot /></component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

/**
 * UiContainer — Vuetify <v-container> replacement.
 * Centers content and applies a max width; `fluid` removes the max width.
 */
withDefaults(
  defineProps<{
    fluid?: boolean
    tag?: string
  }>(),
  { fluid: false, tag: 'div' },
)

const classes = computed(() =>
  ['w-full', 'px-4', 'mx-auto', 'max-w-none'].join(' '),
)
</script>
